export default {
  default: () => import("/vercel/path0/layouts/default.vue").then(m => m.default || m),
  maintenance: () => import("/vercel/path0/layouts/maintenance.vue").then(m => m.default || m)
}